import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { VscGripper } from "react-icons/vsc";
import { getOrdinalSuffixOf } from "components/EnsembleComponents/Summary/ChillerPlantSummary/ChillerRotation/constants";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemContainerStyle = (isDragging, draggableStyle, { width, height }) => ({
  userSelect: "none",
  padding: "5px",
  marginBottom: "5px",
  background: isDragging ? "#fff" : "#fff",
  color: "#555555",
  lineHeight: "42px",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  height: height ? height: "35px",
  width: width ? width: "200px",
  ...draggableStyle,
});

const getItemStyle = ({ width, height }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  boxShadow: "0px 1px 2px 0px #0000001a",
  border: "1px solid #cccccc",
  borderRadius: "6px",
  height: "inherit",
  width: "100%",
})

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#fff" : "#fff",
  width: "fit-content",
});

const SortableList = ({ items = [], onSortChange = () => null, width, height }) => {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const updatedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );
    onSortChange(updatedItems);
  };

  //console.log("...render", items);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {items.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemContainerStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style,
                      { width, height }
                    )}
                  >
                    {
                        item.rawData && item.rawData.sequenceNumber !== undefined ? 
                          <div style={{marginRight: "7px", fontWeight: "600", minWidth: "27px"}}>{getOrdinalSuffixOf(Number(item.rawData.sequenceNumber))}</div> : null
                    }
                    <div
                      style={getItemStyle({ width, height })}
                    >
                      <VscGripper style={{ fontSize: "21px", color: "#000"}} />
                      {item.content}
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SortableList;
